import React, { Component } from 'react'
import Field from 'components/controls/field'
import { onChange } from 'shared/helpers/functional'
import { isThirdParty } from 'shared/helpers/user'
import {
  __,
  map,
  prop,
  sort,
  isNil,
  ascend,
  pathEq,
  propOr,
  compose,
  memoize,
  pathSatisfies,
  pipe,
  values,
  groupBy,
  flatten,
} from 'ramda'
import 'less/scheduler.less'
import CollapsibleTimeSlots from 'containers/collapsible-timeSlots'
import moment from 'moment'
import { timezoneAbbreviationLabel } from 'shared/helpers/user'

const label = (
  startDate,
  endDate,
  t,
  formatDate,
) => {
  console.log("format date in label ", formatDate)
  console.log("translate : ",t)
  return (
  <span className="time-slot">
    <span className="time-slot-date">{formatDate(startDate, 'formatDate')}</span>
    <span className="time-slot-time-range">
      <span className="time-slot-time-start">{formatDate(startDate, 'LT')}</span>
      <span> - </span>
      <span className="time-slot-time-end">{formatDate(endDate, 'LT')}</span>
      <span className="time-zone">{" "+ timezoneAbbreviationLabel(moment.tz.guess())}</span>
    </span>
    <span className="time-slot-duration">{`(${moment(endDate).diff(moment(startDate), 'minutes')} ` + `${t('minutes')})`}</span>
  </span>
  )
}

const sortTimeSlots = memoize(sort(ascend(prop('startTime'))))

class Scheduler extends Component {

  render () {
    const {
      question,
      setAnswerDetails,
      setAnswerProps,
      t,
      formatDate,
      user,
      selectedTimeSlot,
      setSelectedTimeSlot,
      moderatorsAvailability,
      setSelectedTimeSlotDetails
    } = this.props
    /**
     * We get dates back as UTC, need to convert to what we expect
     * otherwise longer dates split out into next day erroneously
     */
    // const moderatorAvailability = question.moderatorAvailability
    const moderatorAvailability = pipe(
      values,
      flatten,
      groupBy(d => formatDate(d.startTime, "YYYY-MM-DD")),
    )(moderatorsAvailability)
    const availableDays = Object.keys(moderatorAvailability)

    /**
     * TODO review - Scheduler specific anomalous behavior
     * our standard has been that answers are serialized into answerDetials
     * for consumption by the API. Here, the API expects additional metadata to be
     * sent when posting an answer to a scheduler question. Can we move these back into
     * answerDetails somehow? The logical inconsistency  with this solution
     * is that the metadata is technically not an "answer" to the question.
     */

    return (
      <div className="scheduler">
          <div className="time-slots">
            {availableDays.sort().map(day =>
              <CollapsibleTimeSlots
                key={day}
                day={day}
                sortTimeSlots={sortTimeSlots}
                label={label}
                isChecked={() => {}}
                onChangeHandler={onChange}
                updateSlot={() => {}}
                t={t}
                formatDate={formatDate}
                availabilityByDay={moderatorAvailability}
                selectedTimeSlot={selectedTimeSlot}
                setSelectedTimeSlot={setSelectedTimeSlot}
                setSelectedTimeSlotDetails = {setSelectedTimeSlotDetails}
              />)}
            <div className={`self-service-na-time-slot`}>
              <Field
                type="radio"
                label={this.props.t('question.time_slots.none')}
                checked={selectedTimeSlot === -2}
                onClick = {() => {setSelectedTimeSlot(-2); setSelectedTimeSlotDetails({})}}
              />
            </div>
          </div>
       </div>
    )
  }
}

export default Scheduler
